$shm_ba_mention_stats_task_list $shm_service_task_list
	task_id? \
	List_head $shm_ba_mention_stats_task_list_head
		title <= title
		filter? <=> filter? \
		add? <=> add?
		search_showed <= search_showed false
		Close null
		Settings null
	add? <=> task_add? null
	task_add? null
